import React from 'react';

function About () {
  return (
    <div className="google-slides-container">
      <iframe src="https://docs.google.com/presentation/d/e/2PACX-1vTXhPAeRY-Hk6Q3dokjLtwNWS6YAhFa4bL4mZZosLcS4sydggCKQPzUqoIckrTiHkBhLSRcZVJ98-Zq/embed?start=false&loop=false&delayms=3000" frameborder="0" width="1200" height="711" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>   \
    </div>
  );
};

export default About;



